import { WidgetId } from '@brandclub/types';

var getProductDetailsRouteMatch = function (route) {
    return route.match(/^\/([^/?#]+)\/p\/([^/?#]+)\/product/);
};
var checkAndAppendRoutePrefixToLink = function (brandIdString, routePrefix, linkTo) {
    var returnValue = linkTo;
    if (returnValue.indexOf("/b/".concat(brandIdString)) >= 0) {
        returnValue = returnValue.substring(returnValue.indexOf("/b/".concat(brandIdString)) + "/b/".concat(brandIdString).length);
    }
    if (routePrefix && returnValue.indexOf('/p/') < 0) {
        returnValue = "".concat(routePrefix).concat(returnValue);
    }
    return returnValue;
};
var extractSkuFromLink = function (link) {
    if ((link === null || link === void 0 ? void 0 : link.id) && (link === null || link === void 0 ? void 0 : link.displayName)) {
        var routeMatch = getProductDetailsRouteMatch(link.id);
        if ((routeMatch === null || routeMatch === void 0 ? void 0 : routeMatch.length) && routeMatch.length >= 3) {
            return routeMatch[2];
        }
    }
    return;
};
var extractSkuFromLinkItems = function (items) {
    if (items) {
        var skus = [];
        for (var i = 0; i < items.length; i++) {
            var sku = extractSkuFromLink(items[i]);
            if (sku) {
                skus.push(sku);
            }
        }
        return skus;
    }
    return [];
};
var getSideBySideProductsSkus = function (widget) {
    var _a, _b, _c, _d;
    var defaultValue = 'Add product';
    var skus = [];
    var leftSku = (_b = (_a = widget.propsConfig) === null || _a === void 0 ? void 0 : _a.leftProduct) === null || _b === void 0 ? void 0 : _b.propValue;
    var rightSku = (_d = (_c = widget.propsConfig) === null || _c === void 0 ? void 0 : _c.rightProduct) === null || _d === void 0 ? void 0 : _d.propValue;
    if (leftSku && leftSku !== defaultValue) {
        skus.push(leftSku);
    }
    if (rightSku && rightSku !== defaultValue) {
        skus.push(rightSku);
    }
    return Array.from(new Set(skus));
};
var getCuratedProductsSkus = function (widget) {
    var _a, _b;
    var defaultValue = 'Add products';
    var skus = ((_b = (_a = widget.propsConfig) === null || _a === void 0 ? void 0 : _a.products) === null || _b === void 0 ? void 0 : _b.propValue) || [];
    return skus.filter(function (sku) { return sku !== defaultValue; });
};
/**
 * @returns array of SKUs for
 * - ProductAndText
 * - TextAndProduct
 * - VideoAndProduct
 * - ProductAndVideo
 */
var getProductWidgetSkus = function (widget) {
    var _a, _b, _c;
    var skus = [];
    var defaultValue = 'Add product';
    var sku = (_b = (_a = widget.propsConfig) === null || _a === void 0 ? void 0 : _a.product) === null || _b === void 0 ? void 0 : _b.propValue;
    if (sku && sku !== defaultValue) {
        skus.push(sku);
    }
    if ([WidgetId.ProductAndText, WidgetId.TextAndProduct].includes(widget.widgetId)) {
        var buttonLinkSku = extractSkuFromLink((_c = widget.propsConfig.buttonLink) === null || _c === void 0 ? void 0 : _c.propValue);
        if (buttonLinkSku) {
            skus.push(buttonLinkSku);
        }
    }
    return skus;
};
/**
 * @returns array of SKUs for
 * - VideoAndText
 * - TextAndVideo
 */
var getVideoTextSkus = function (widget) {
    var _a;
    var buttonLinkSku = extractSkuFromLink((_a = widget.propsConfig.buttonLink) === null || _a === void 0 ? void 0 : _a.propValue);
    return buttonLinkSku ? [buttonLinkSku] : [];
};
var getBrandHeaderSkus = function (widget) {
    var _a, _b;
    var sku = extractSkuFromLink((_b = (_a = widget.propsConfig) === null || _a === void 0 ? void 0 : _a.buttonLink) === null || _b === void 0 ? void 0 : _b.propValue);
    return sku ? [sku] : [];
};
var getBrandHeaderWithImageSkus = function (widget) {
    var _a, _b;
    var sku = extractSkuFromLink((_b = (_a = widget.propsConfig) === null || _a === void 0 ? void 0 : _a.imageLink) === null || _b === void 0 ? void 0 : _b.propValue);
    return sku ? [sku] : [];
};
var getBrandHeaderWithMultipleImagesSkus = function (widget) {
    var _a, _b, _c, _d;
    var skus = [];
    var mainImageSku = extractSkuFromLink((_b = (_a = widget.propsConfig) === null || _a === void 0 ? void 0 : _a.imageLink) === null || _b === void 0 ? void 0 : _b.propValue);
    if (mainImageSku) {
        skus.push(mainImageSku);
    }
    var imageLinks = (((_d = (_c = widget.propsConfig) === null || _c === void 0 ? void 0 : _c.items) === null || _d === void 0 ? void 0 : _d.propValue) || []).map(function (val) { return val === null || val === void 0 ? void 0 : val.imageLink; });
    skus.push.apply(skus, extractSkuFromLinkItems(imageLinks));
    return skus;
};
var getBrandHeaderWithMultipleVideosSkus = function (widget) {
    var _a, _b;
    var imageLinks = (((_b = (_a = widget.propsConfig) === null || _a === void 0 ? void 0 : _a.items) === null || _b === void 0 ? void 0 : _b.propValue) || []).map(function (val) { return val === null || val === void 0 ? void 0 : val.imageLink; });
    return extractSkuFromLinkItems(imageLinks);
};
var getSixRectangleBoxesSkus = function (widget) {
    var _a, _b;
    var links = (((_b = (_a = widget.propsConfig) === null || _a === void 0 ? void 0 : _a.items) === null || _b === void 0 ? void 0 : _b.propValue) || []).map(function (val) { return val === null || val === void 0 ? void 0 : val.link; });
    return extractSkuFromLinkItems(links);
};
var getRectangleImageCarouselSkus = function (widget) {
    var _a, _b;
    var links = (((_b = (_a = widget.propsConfig) === null || _a === void 0 ? void 0 : _a.items) === null || _b === void 0 ? void 0 : _b.propValue) || []).map(function (val) { return val === null || val === void 0 ? void 0 : val.link; });
    return extractSkuFromLinkItems(links);
};
var getSideBySideImagesSkus = function (widget) {
    var _a, _b, _c, _d, _e, _f;
    var skus = [];
    var leftImageLink = extractSkuFromLink((_c = (_b = (_a = widget.propsConfig.leftImage) === null || _a === void 0 ? void 0 : _a.propsConfig) === null || _b === void 0 ? void 0 : _b.link) === null || _c === void 0 ? void 0 : _c.propValue);
    var rightImageLink = extractSkuFromLink((_f = (_e = (_d = widget.propsConfig.rightImage) === null || _d === void 0 ? void 0 : _d.propsConfig) === null || _e === void 0 ? void 0 : _e.link) === null || _f === void 0 ? void 0 : _f.propValue);
    if (leftImageLink) {
        skus.push(leftImageLink);
    }
    if (rightImageLink) {
        skus.push(rightImageLink);
    }
    return skus;
};
var getImagePairWidgetSkus = function (widget) {
    var _a, _b;
    var skus = [];
    var sku = extractSkuFromLink((_a = widget.propsConfig.imageLink) === null || _a === void 0 ? void 0 : _a.propValue);
    var buttonLinkSku = extractSkuFromLink((_b = widget.propsConfig.buttonLink) === null || _b === void 0 ? void 0 : _b.propValue);
    if (sku) {
        skus.push(sku);
    }
    if (buttonLinkSku) {
        skus.push(buttonLinkSku);
    }
    return skus;
};
/**
 * @returns array of SKUs for
 * - CenterProductHero
 * - ShortWideBanner
 * - LargeCenterImage
 * - MediumCenterImage
 */
var getImageLinkSkus = function (widget) {
    var _a;
    var sku = extractSkuFromLink((_a = widget.propsConfig.link) === null || _a === void 0 ? void 0 : _a.propValue);
    return sku ? [sku] : [];
};
var extractSKUFromWidget = function (widget) {
    switch (widget.widgetId) {
        case WidgetId.SideBySideProducts:
            return getSideBySideProductsSkus(widget);
        case WidgetId.CuratedProducts:
            return getCuratedProductsSkus(widget);
        case WidgetId.ProductAndText:
        case WidgetId.TextAndProduct:
        case WidgetId.VideoAndProduct:
        case WidgetId.ProductAndVideo:
            return getProductWidgetSkus(widget);
        case WidgetId.VideoAndText:
        case WidgetId.TextAndVideo:
            return getVideoTextSkus(widget);
        case WidgetId.BrandHeader:
            return getBrandHeaderSkus(widget);
        case WidgetId.BrandHeaderWithImage:
            return getBrandHeaderWithImageSkus(widget);
        case WidgetId.BrandHeaderWithMultipleImages:
            return getBrandHeaderWithMultipleImagesSkus(widget);
        case WidgetId.BrandHeaderWithMultipleVideos:
            return getBrandHeaderWithMultipleVideosSkus(widget);
        case WidgetId.SixRectangleBoxes:
            return getSixRectangleBoxesSkus(widget);
        case WidgetId.RectangleImageCarousel:
            return getRectangleImageCarouselSkus(widget);
        case WidgetId.CenterProductHero:
        case WidgetId.ShortWideBanner:
        case WidgetId.LargeCenterImage:
        case WidgetId.MediumCenterImage:
            return getImageLinkSkus(widget);
        case WidgetId.ImageAndText:
        case WidgetId.TextAndImage:
            return getImagePairWidgetSkus(widget);
        case WidgetId.SideBySideImages:
            return getSideBySideImagesSkus(widget);
        default:
            return [];
    }
};
var extractSKUFromWidgets = function (widgets) {
    if (!widgets)
        return [];
    var skus = [];
    for (var i = 0; i < widgets.length; i++) {
        var widgetSkus = extractSKUFromWidget(widgets[i]);
        if (Array.isArray(widgetSkus)) {
            skus.push.apply(skus, widgetSkus);
        }
    }
    return Array.from(new Set(skus));
};

export { checkAndAppendRoutePrefixToLink, extractSKUFromWidgets };
//# sourceMappingURL=widgetUtils.js.map
